import React, { PureComponent } from 'react';
import Confetti from './Confetti';
import './Confetti.scss';

class ConfettiContainer extends PureComponent {
  renderConfetti() {
    const { amount } = this.props;
    const confetti = [];
    for (let i = 0; i < amount; i++) {
      confetti.push(<Confetti key={i} />);
    }
    return confetti;
  }

  render() {
    const { children } = this.props;
    return (
      <div className="confetti-container">
        <div className="confetti-container-top">
          {this.renderConfetti()}
        </div>

        <div className="children-container">
          {children}
        </div>

        <div className="confetti-container-bottom">
          {this.renderConfetti()}
        </div>
      </div>
    );
  }
}
ConfettiContainer.defaultProps = { amount: 20 };

export { ConfettiContainer };


// WEBPACK FOOTER //
// ./src/components/ConfettiContainer.js